import { IGGSTextFieldFactory } from "./IGGSTextFieldFactory";
import { GoodgameInputTextField } from "../textfield/GoodgameInputTextField";
import { GoodgameTextField } from "../textfield/GoodgameTextField";
import { IInternalGGSTextField } from "../textfield/IInternalGGSTextField";
import { TextFieldType } from "@goodgamestudios/createjs-utilities";
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../../index";

import { TextField } from "@goodgamestudios/createjs-utilities";

const logger = getLogger(TEXT_FIELDS_LOGGER+".GoodgameAdvancedTextFieldFactory");
export class GoodgameAdvancedTextFieldFactory implements IGGSTextFieldFactory {
    public createAdvancedTextField(textfield: TextField): IInternalGGSTextField {
        logger.debug("createAdvancedTextField for",  textfield);
        if (textfield.type == TextFieldType.INPUT) {
            return new GoodgameInputTextField(textfield);
        }

        return new GoodgameTextField(textfield);
    }
}
